import ApiService from "../auth/ApiService";
import _ from "lodash";
const apiEndpoint = ApiService.API_URL;
const resourceUrl = apiEndpoint + "/secured/download-requests";

const DownloadRequestAPI = {
  all: async function (page, size) {
    let response = await new ApiService().callApi(resourceUrl + "?page=" + page + "&size=" + size, "get");
    return response.data;
  }
};

export default DownloadRequestAPI;
